module.exports = __webpack_public_path__ + "img/vi.aed94a21.png";